import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Typography,
  Link,
} from '@mui/material';

function VisaStatistique() {
  const pdfLink = "/documents/ordonances/Ordonnance-ministérielle-n°-5401643-du-25-novembre-2013-portant-modalités-dobtention-du-visa-statistique-pour-les-enquêtes-statistiques-au-Burundi.pdf";

  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Visa Statistique au Burundi
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Au Burundi, la régulation des enquêtes statistiques est essentielle pour assurer la qualité et la validité des données collectées, qui jouent un rôle crucial dans le développement économique et social du pays. L'Ordonnance ministérielle n° <Link href={pdfLink} target="_blank" rel="noopener noreferrer" style={{ color: 'red', transition: 'color 0.3s ease' }}>540/1643 du 25 novembre 2013</Link> portant modalités d'obtention du visa statistique pour les enquêtes statistiques établit un cadre juridique strict visant à encadrer la conduite de ces enquêtes. Cette ordonnance met en place un processus rigoureux pour l'obtention d'un visa statistique, essentiel pour toute recherche ou enquête devant être menée dans le pays.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Le visa statistique, délivré par le Ministre en charge de la Planification du Développement Économique, repose sur l'avis d'opportunité et de conformité émis par le Comité Technique de l’Information Statistique (CTIS). Ce dispositif a pour but de garantir que les enquêtes répondent aux normes éthiques et méthodologiques requises, garantissant ainsi leur fiabilité et leur intégrité.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Cette analyse des modalités d'obtention du visa statistique entend clarifier les différentes étapes du processus, les obligations des requérants et les rôles respectifs des autorités impliquées. En outre, elle mettra en lumière l'importance de cette ordonnance dans la promotion d'une culture de données fiables et éthiques au Burundi, tout en soutenant les initiatives ayant un impact sur le développement national. Le respect de ces modalités est non seulement une exigence légale, mais aussi un impératif pour favoriser un environnement de recherche respectueux des droits des individus et des standards éthiques internationaux.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Voir aussi : <br />
          <Link
            component={RouterLink}
            to="/visaInformation"
            sx={{
              color: 'green',
              
              transition: 'color 0.3s ease',
              '&:hover': {
                color: 'darkgreen',
                textDecoration: 'underline',
              },
            }}
          >
            Informations sur le Visa
          </Link> <br />
          <Link
            component={RouterLink}
            to="/visaActor"
            sx={{
              color: 'green',
            
              transition: 'color 0.3s ease',
              '&:hover': {
                color: 'darkgreen',
                textDecoration: 'underline',
              },
            }}
          >
            Visas autorisés
          </Link> <br />
          <Link
            href="/documents/visa/Fiche_visa_Insbu.pdf"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'green',
              
              transition: 'color 0.3s ease',
              '&:hover': {
                color: 'darkgreen',
                textDecoration: 'underline',
              },
            }}
          >
            Fiche d'information et de demande de visa Statistique
          </Link>
        </Typography>
      </Container>
      <Footer />
    </div>
  );
}

export default VisaStatistique;